import React from 'react';

import { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { connect, disconnect, subscribe, unsubscribe } from '../services/ws-service'
import Lobby from './Lobby/Lobby';
import { useRef } from 'react';
import axios from '../services/api-axios';
// import Game from './Game/Game'
import { useSelector, useDispatch } from 'react-redux';
import { joinTeam, leaveTeam, appendParticipant, removeParticipant, setParitipants, setTeam, setHost, setReadyPlayers, setBots, setSessionTarget, setLobbiesList, disconnectFromLobby } from '../store/lobbySlice'
import { append, remove } from '../store/onlineUsersSlice'
import { invite } from '../store/inviteSlice';
import { setGameId, setMiddle, setHand, appendMiddle, setPlayerTurn, setSomethingHappend, reducePlayerCardCount, resetPlayerCardCount, setPlayersInitially, setGameState } from '../store/gameSlice';
import Marjan from './Game/GameBoard';
import Header from './Home/Header';
import useGameMessageHandler from '../message-handler/useGameMessageHandler';
import usePrivateMessageHandler from '../message-handler/usePrivateMessageHandler';
import usePublicMessageHandler from '../message-handler/usePublicMessageHandler';
import useInviteMessageHandler from '../message-handler/useInviteMessageHandler';
import useLobbyMessageHandler from '../message-handler/useLobbyMessageHandler';
import { Outlet } from 'react-router-dom';
// SockJS requires an absolute URL; derive it from the serving origin when unset
// so the same build works locally and behind the public domain.
const WS_URL = process.env.REACT_APP_WS_URL || `${window.location.origin}/stompwebsocket`;

const WsContainer = () => {
    const lobbyId = useSelector((state) => state.lobby.lobbyId)
    const onGameMessageReceived = useGameMessageHandler();
    const onPrivateMessageReceived = usePrivateMessageHandler();
    const onPublicMessageReceived = usePublicMessageHandler();
    const onInviteReceived = useInviteMessageHandler();
    // const onLobbyMessage = useLobbyMessageHandler();
    const token = localStorage.getItem("SavedToken")
    var header = {
        "jwt-token": token
    }
    // const gameRef = useRef(null);
    const dispatch = useDispatch()

    const currentGameId = useSelector((state) => state.game.gameId);
    const gameIdRef = useRef(null);
    useEffect(() => {
        gameIdRef.current = currentGameId;
    }, [currentGameId]);

    // The connect effect runs once, so the reconnect handler it closes over cannot
    // read lobbyId directly.
    const lobbyIdRef = useRef(null);
    useEffect(() => {
        lobbyIdRef.current = lobbyId;
    }, [lobbyId]);

    useEffect(() => {


        const onConnected = () => {
            console.log('Connected to WebSocket');
            subscribe("/topic/public", onPublicMessageReceived);
            subscribe("/user/queue/private", onPrivateMessageReceived)
            subscribe("/user/queue/invitations", onInviteReceived);
        };

        // ws-service reopens every subscription itself, so this only has to repair
        // the state that a dead socket took with it.
        const onReconnected = async () => {
            console.log('Reconnected to WebSocket');

            const lobbyId = lobbyIdRef.current;
            if (lobbyId) {
                // Dropping the socket removed us from the lobby server-side. Claiming
                // membership again is what makes the restored subscription meaningful:
                // without it we sit in a lobby the server no longer counts us in, and
                // that lobby can never be emptied or deleted.
                try {
                    await axios.post('/rest/lobby/join/', { lobbyId });
                    const res = await axios.get(`/rest/lobby/info/${lobbyId}`);
                    dispatch(setParitipants(res.data.participants));
                    dispatch(setTeam({ team: 'TEAM1', users: res.data.team1 }));
                    dispatch(setTeam({ team: 'TEAM2', users: res.data.team2 }));
                    dispatch(setHost(res.data.host));
                    dispatch(setReadyPlayers(res.data.readyPlayers || []));
                    dispatch(setBots(res.data.botDifficulties || {}));
                    dispatch(setSessionTarget(res.data.sessionTarget || undefined));
                } catch (error) {
                    // The lobby was deleted while we were away — leave it rather than
                    // showing a room nobody else is in.
                    console.error('Could not rejoin lobby after reconnect:', error);
                    unsubscribe(`/topic/public/lobby/${lobbyId}`);
                    dispatch(disconnectFromLobby());
                }
            }

            // Lobby lifecycle messages sent while we were offline are gone for good,
            // so the list has to come from the server again.
            try {
                const res = await axios.get('/rest/lobby');
                dispatch(setLobbiesList({ lobbies: res.data }));
            } catch (error) {
                console.error('Failed to refresh lobbies after reconnect:', error);
            }

            const gameId = gameIdRef.current;
            if (gameId) {
                try {
                    const res = await axios.get(`/rest/game/${gameId}/state`);
                    dispatch(setGameState({
                        hand: res.data.hand,
                        middle: res.data.middle,
                        playerTurn: res.data.playerTurn,
                        players: res.data.cardCounts,
                        currentRound: res.data.round,
                    }));
                } catch (error) {
                    console.error('Failed to resync game state after reconnect:', error);
                }
            }
        };

        const onError = (error) => {
            console.error('Error connecting to WebSocket:', error);
        };

        connect(WS_URL, header, onConnected, onError, onReconnected);

        return () => {
            // Cleanup: Disconnect when the component unmounts
            console.log("DISCONECTING")
            disconnect();
        };
    }, []); // Empty dependency array ensures that this effect runs once

    // Unsubscribe from the channel when needed
    // const handleUnsubscribe = () => {
    //     console.log('%cWsContainer::handleUnsubscribe:::::::::::::::::::::::::', 'background-color: #faa0a0')
    //     unsubscribe('/user/queue/private');
    // };
    // const handleSubscribeLobby = (lobbyId) => {
        // console.log('%cWsContainer::handleSubscribeLobby:::::::::::::::::::::::::' + lobbyId, 'background-color: lightgreen')
        // subscribe(`/topic/public/lobby/${lobbyId}`, onLobbyMessage);
    // };
    // const handleUnsubscribeLobby = (lobbyId) => {
        // console.log('%cWsContainer::handleUnsubscribeLobby:::::::::::::::::::::::::' + lobbyId, 'background-color: #faa0a0')
        // unsubscribe('/topic/public/lobby/' + lobbyId);
    // };

    return (
        <>
            <Header />
            <Outlet />
        </>
    );

}

export default WsContainer;